module.exports = __webpack_public_path__ + "static/JG3-b68ca1083b525c379c0ca0294b4bd430.png";